// Exporta el ABI del router como un array JS para importar fácilmente en hooks
import abi from './DEXRouter.json';
export default abi;
